<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar class="slide-card-up mb-8" dense :color="'FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row dense class="slide-card-up" justify="center">
            <h1 v-if="!esIndividual && camino != null" class="mt-0 ma-4 mr-12">{{ $t('mensajes.inicial') }} {{ esAgencia ?
                this.agencia.nombre : '' }}</h1>
        </v-row>
        <v-row v-if="!esIndividual && camino != null" dense class="slide-card-up">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    {{ $t('mensajes.descripcion') }}
                </p>
            </v-col>
        </v-row>

        <v-container>
            <v-row justify="center">
                <v-col cols="12" md="10" lg="8">
                    <v-card class="mx-2 pa-6 card-personalizada slide-card">
                        <div v-if="cargando" class="text-center py-8" role="status" aria-live="polite">
                            <v-progress-circular indeterminate :color="miColorNaranja" size="48" />
                            <p class="mt-4">{{ copy.cargando }}</p>
                        </div>
                        <v-alert v-else-if="errorCarga" type="error" outlined role="alert">
                            {{ errorCarga }}
                            <v-btn text small @click="_cargarAutorizacion()">{{ copy.reintentar }}</v-btn>
                        </v-alert>

                        <div v-if="datosCargados" class="text-center mb-6">
                            <div class="text-subtitle-2">{{ fechaTexto }}</div>
                            <div class="text-h6 font-weight-bold">{{ tituloAutorizacion }}</div>
                            <div v-if="esIndividual" class="mt-3">{{ copy.reserva }}: {{ modelReserva.codigo }}</div>
                        </div>

                        <v-row v-if="autorizacionEnviada" dense class="mb-4">
                            <v-col cols="12">
                                <v-alert type="success" dense outlined>
                                    {{ yaCompletada ? copy.yaCompletada : copy.mensajeExito }}
                                </v-alert>
                            </v-col>
                        </v-row>

                        <v-alert v-if="errorEnvio" type="error" outlined role="alert">{{ errorEnvio }}</v-alert>

                        <v-form v-if="mostrarFormulario" ref="formAutorizacion" @submit.prevent="_enviarAutorizacion()">
                            <v-row dense>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.numeroTarjeta" :label="labels.numeroTarjeta"
                                        placeholder="VISA / MASTERCARD" outlined dense hide-details="auto"
                                        :rules="rulesNumeroTarjeta" maxlength="16" inputmode="numeric" :disabled="camposDeshabilitados"
                                        @input="onInputNumeroTarjeta"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.fechaCaducidad" :label="labels.fechaCaducidad"
                                        placeholder="MM/AA" outlined dense hide-details="auto"
                                        :rules="rulesCaducidad" maxlength="5" :disabled="camposDeshabilitados"
                                        @input="onInputCaducidad"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.titularTarjeta" :label="labels.titularTarjeta"
                                        outlined dense hide-details="auto" :rules="rulesTitular" maxlength="255" :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.importeCarga" :label="labels.importeCarga"
                                        outlined dense hide-details :readonly="esIndividual" :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <div class="text-h6 mt-6">
                                        {{ copy.depositoIntro }}
                                    </div>
                                </v-col>
                                
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.importeDeposito" :label="labels.importeDeposito"
                                        outlined dense hide-details :readonly="esIndividual" :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field ref="fechaDeposito" v-model="autorizacion.fechaDeposito" :label="labels.fechaDeposito"
                                        placeholder="__/__/____" outlined dense hide-details="auto"
                                        :rules="rulesFechaDeposito" maxlength="10" :disabled="camposDeshabilitados"
                                        @input="onInputFechaDeposito"></v-text-field>
                                    <div class="caption grey--text mt-1">{{ copy.formatoFecha }}</div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="text-h6 mt-6">
                                        {{ copy.restoIntro }}
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="autorizacion.importeResto" :label="labels.importeResto"
                                        outlined dense hide-details readonly :disabled="camposDeshabilitados"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row v-if="mostrarFormulario && !(esIndividual && autorizacionEnviada)" justify="center" class="mt-6">
                            <v-btn rounded large depressed @click="_enviarAutorizacion()" class="ma-2 px-6"
                                :class="{ 'hover-color': puedeEnviarAutorizacion }"
                                :color="puedeEnviarAutorizacion ? miColorAzul : 'grey'"
                                :style="{ color: puedeEnviarAutorizacion ? miColorNaranja : 'white' }"
                                :loading="loadingEnviandoAutorizacion" :disabled="!puedeEnviarAutorizacion">
                                {{ copy.enviar }}
                                <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                            </v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { obtenerAutorizacionIndividual, completarAutorizacionIndividual } from '@/services/autorizacionTarjeta';

export default {
    data() {
        return {
            language: 'es',

            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            miColorAmarillo: '#FFF6E5',

            loadingEnviandoAutorizacion: false,
            hash: null,
            autorizacionEnviada: false,
            yaCompletada: false,
            cargando: true,
            datosCargados: false,
            errorCarga: '',
            errorEnvio: '',
            pasajeroNombre: '',
            solicitudCarga: 0,

            autorizacion: {
                numeroTarjeta: '',
                fechaCaducidad: '',
                titularTarjeta: '',
                importeCarga: '',
                importeDeposito: '100',
                fechaDeposito: '',
                importeResto: '',
            },

            modelReserva: {
                id: null,
                codigo: null,
                camino: null,
                fecha_inicio: null,
                fecha_llegada: null,
                cant_peregrinos: 0,
                importe_presupuestado: 0,
                cliente: {
                    nombre: '',
                    apellidos: '',
                    telefono: '',
                    email: '',
                },
            },
        };
    },
    computed: {
        ...mapState('caminos', ['camino', 'agencia']),

        esIndividual() {
            return this.$route.name === 'autorizacionTarjetaPasajero';
        },

        mostrarFormulario() {
            return this.datosCargados && !this.cargando && !this.errorCarga;
        },

        localeActual() {
            const locale = this.language || (this.$i18n && this.$i18n.locale) || 'es';
            return locale.toLowerCase();
        },

        copy() {
            const textos = {
                es: {
                    clienteGenerico: 'cliente',
                    titulo: 'Autorizacion de {nombre} para el uso de la siguiente tarjeta de credito en el cargo de los servicios proporcionados por RUTAS MEIGAS SL',
                    depositoIntro: 'Estoy de acuerdo con que se carguen el siguiente deposito en la fecha indicada:',
                    restoIntro: 'Estoy de acuerdo con que se cargue el resto de la reserva 10 días antes de la fecha de inicio de la misma.',
                    mensajeExito: 'Se ha enviado la autorizacion correctamente. Gracias',
                    yaCompletada: 'Esta autorización ya está completada. Gracias.',
                    cargando: 'Cargando autorización…',
                    errorCarga: 'No se ha podido cargar la autorización. Inténtalo de nuevo.',
                    enlaceInvalido: 'El enlace de autorización no está disponible. Contacta con Rutas Meigas.',
                    errorEnvio: 'No se ha podido enviar la autorización. Inténtalo de nuevo.',
                    errorValidacion: 'Revisa los datos de tarjeta, titular y fecha del depósito.',
                    titularObligatorio: 'Introduce el titular de la tarjeta (máximo 255 caracteres).',
                    fechaInvalida: 'Introduce una fecha válida con formato DD/MM/AAAA.',
                    reintentar: 'Reintentar', reserva: 'Reserva', enviar: 'Enviar autorización',
                    formatoFecha: 'Formato: DD/MM/AAAA',
                    labels: {
                        numeroTarjeta: 'Número de tarjeta de credito (VISA / MASTERCARD)',
                        fechaCaducidad: 'Fecha de caducidad (MM/AA)',
                        titularTarjeta: 'Titular',
                        importeCarga: 'Importe a cargar (EUR)',
                        importeDeposito: 'Deposito a cargar (EUR)',
                        fechaDeposito: 'Fecha del deposito',
                        importeResto: 'Resto de la reserva (EUR)',
                    },
                },
                en: {
                    clienteGenerico: 'customer',
                    titulo: 'Authorization of {nombre} to use the following credit card for the charge of the services provided by RUTAS MEIGAS SL',
                    depositoIntro: 'I agree that the following deposit will be charged on the specified date:',
                    restoIntro: 'I agree that the remaining balance will be charged 10 days before the start date.',
                    mensajeExito: 'Authorization sent successfully. Thank you',
                    yaCompletada: 'This authorization has already been completed. Thank you.',
                    cargando: 'Loading authorization…',
                    errorCarga: 'The authorization could not be loaded. Please try again.',
                    enlaceInvalido: 'This authorization link is unavailable. Please contact Rutas Meigas.',
                    errorEnvio: 'The authorization could not be sent. Please try again.',
                    errorValidacion: 'Please check the card details, cardholder and deposit date.',
                    titularObligatorio: 'Enter the cardholder name (up to 255 characters).',
                    fechaInvalida: 'Enter a valid date in DD/MM/YYYY format.',
                    reintentar: 'Try again', reserva: 'Booking', enviar: 'Send authorization',
                    formatoFecha: 'Format: DD/MM/YYYY',
                    labels: {
                        numeroTarjeta: 'Credit card number (VISA / MASTERCARD)',
                        fechaCaducidad: 'Expiry date (MM/YY)',
                        titularTarjeta: 'Cardholder',
                        importeCarga: 'Amount to charge (EUR)',
                        importeDeposito: 'Deposit to charge (EUR)',
                        fechaDeposito: 'Deposit charge date',
                        importeResto: 'Remaining balance (EUR)',
                    },
                },
                de: {
                    clienteGenerico: 'Kunde',
                    titulo: 'Autorisierung von {nombre} zur Nutzung der folgenden Kreditkarte fur die Belastung der von RUTAS MEIGAS SL erbrachten Leistungen',
                    depositoIntro: 'Ich stimme zu, dass die folgende Anzahlung am angegebenen Datum belastet wird:',
                    restoIntro: 'Ich stimme zu, dass der Restbetrag 10 Tage vor dem Startdatum belastet wird.',
                    mensajeExito: 'Autorisierung erfolgreich gesendet. Vielen Dank',
                    yaCompletada: 'Diese Autorisierung wurde bereits ausgefüllt. Vielen Dank.',
                    cargando: 'Autorisierung wird geladen…',
                    errorCarga: 'Die Autorisierung konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
                    enlaceInvalido: 'Dieser Autorisierungslink ist nicht verfügbar. Bitte kontaktieren Sie Rutas Meigas.',
                    errorEnvio: 'Die Autorisierung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
                    errorValidacion: 'Bitte prüfen Sie die Kartendaten, den Karteninhaber und das Anzahlungsdatum.',
                    titularObligatorio: 'Geben Sie den Karteninhaber an (maximal 255 Zeichen).',
                    fechaInvalida: 'Geben Sie ein gültiges Datum im Format TT/MM/JJJJ ein.',
                    reintentar: 'Erneut versuchen', reserva: 'Buchung', enviar: 'Autorisierung senden',
                    formatoFecha: 'Format: TT/MM/JJJJ',
                    labels: {
                        numeroTarjeta: 'Kreditkartennummer (VISA / MASTERCARD)',
                        fechaCaducidad: 'Ablaufdatum (MM/JJ)',
                        titularTarjeta: 'Karteninhaber',
                        importeCarga: 'Zu belastender Betrag (EUR)',
                        importeDeposito: 'Anzahlung (EUR)',
                        fechaDeposito: 'Datum der Anzahlung',
                        importeResto: 'Restbetrag (EUR)',
                    },
                },
            };
            return textos[this.localeActual] || textos.es;
        },

        labels() {
            return this.copy.labels;
        },

        rulesNumeroTarjeta() {
            return [
                (v) => {
                    const digits = String(v || '').replace(/\D/g, '');
                    return digits.length === 16 || 'El numero de tarjeta debe tener 16 digitos';
                },
            ];
        },

        rulesCaducidad() {
            return [
                (v) => {
                    const valor = String(v || '');
                    if (!/^\d{2}\/\d{2}$/.test(valor)) return 'Formato MM/AA';
                    const [mm] = valor.split('/');
                    const mes = Number(mm);
                    return mes >= 1 && mes <= 12 || 'Mes invalido';
                },
            ];
        },

        rulesTitular() {
            return this.esIndividual ? [
                v => (!!String(v || '').trim() && String(v).trim().length <= 255) || this.copy.titularObligatorio,
            ] : [];
        },

        rulesFechaDeposito() {
            return [
                (v) => {
                    const valor = String(v || '');
                    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) return 'Formato dd/mm/aaaa';
                    const [dd, mm, yyyy] = valor.split('/');
                    const dia = Number(dd);
                    const mes = Number(mm);
                    const ano = Number(yyyy);
                    if (mes < 1 || mes > 12) return 'Mes invalido';
                    if (dia < 1 || dia > 31) return 'Dia invalido';
                    if (ano < 1900) return 'Ano invalido';
                    const fecha = new Date(ano, mes - 1, dia);
                    return (fecha.getFullYear() === ano && fecha.getMonth() === mes - 1 && fecha.getDate() === dia) || this.copy.fechaInvalida;
                },
            ];
        },

        clienteNombreCompleto() {
            if (this.esIndividual) return this.pasajeroNombre || this.copy.clienteGenerico;
            const nombre = this.modelReserva.cliente.nombre || '';
            const apellidos = this.modelReserva.cliente.apellidos || '';
            const full = `${nombre} ${apellidos}`.trim();
            return full || this.copy.clienteGenerico;
        },

        tituloAutorizacion() {
            return this.copy.titulo.replace('{nombre}', this.clienteNombreCompleto);
        },

        fechaTexto() {
            return this.formatFecha(new Date());
        },

        camposAutorizacionCompletos() {
            return this.validarCamposAutorizacion();
        },

        camposDeshabilitados() {
            return !this.datosCargados || this.cargando || !!this.errorCarga || this.autorizacionEnviada || this.loadingEnviandoAutorizacion;
        },

        puedeEnviarAutorizacion() {
            return !this.camposDeshabilitados && !!this.hash && this.camposAutorizacionCompletos;
        },

        esAgencia() {
            return this.agencia != null && this.agencia.id != 1;
        },
    },
    watch: {
        '$route.fullPath'() {
            this._cargarAutorizacion();
        },
        'autorizacion.importeDeposito'() {
            this._actualizarImporteResto();
        },
        'modelReserva.importe_presupuestado'() {
            if (this.esIndividual) return;
            if (!this.autorizacion.importeCarga) {
                this.autorizacion.importeCarga = this._formatNumero(this.modelReserva.importe_presupuestado);
            }
            this._actualizarImporteResto();
        },
    },

    mounted() {
        this._cargarAutorizacion();
    },

    beforeDestroy() {
        this.solicitudCarga++;
        this._limpiarTarjeta();
    },

    methods: {
        ...mapActions('caminos', ['getReservaByHash', 'guardarAutorizacionTarjeta']),

        async _cargarAutorizacion() {
            const solicitud = ++this.solicitudCarga;
            const idioma = String(this.$route.params.language || 'es').toLowerCase();
            this.language = ['es', 'en', 'de'].includes(idioma) ? idioma : 'es';
            this.$i18n.locale = this.language;
            this.hash = this.$route.params.hash || null;
            this.cargando = true;
            this.datosCargados = false;
            this.errorCarga = '';
            this.errorEnvio = '';
            this.autorizacionEnviada = false;
            this.yaCompletada = false;
            this.pasajeroNombre = '';
            this.autorizacion = {
                numeroTarjeta: '', fechaCaducidad: '', titularTarjeta: '',
                importeCarga: '', importeDeposito: '100', fechaDeposito: '', importeResto: '',
            };
            this.modelReserva.importe_presupuestado = 0;
            try {
                if (!this.hash) {
                    this.errorCarga = this.copy.enlaceInvalido;
                    return;
                }
                if (this.esIndividual) {
                    const datos = await obtenerAutorizacionIndividual(this.hash);
                    if (solicitud !== this.solicitudCarga) return;
                    if (!datos || !datos.reserva) throw new Error('Respuesta de autorización incompleta');
                    this.modelReserva.codigo = datos.reserva.codigo;
                    this.modelReserva.fecha_inicio = datos.reserva.fecha_inicio;
                    this.modelReserva.fecha_llegada = datos.reserva.fecha_llegada;
                    this.pasajeroNombre = datos.pasajero_nombre || '';
                    const idiomaReserva = String(datos.idioma || '').toLowerCase();
                    if (['es', 'en', 'de'].includes(idiomaReserva)) {
                        this.language = idiomaReserva;
                        this.$i18n.locale = idiomaReserva;
                    }
                    this.autorizacion.importeCarga = this._formatNumero(datos.autorizacion_importecarga);
                    this.autorizacion.importeDeposito = this._formatNumero(datos.autorizacion_importedeposito);
                    this.autorizacion.importeResto = this._formatNumero(datos.autorizacion_importeresto);
                    this.autorizacion.titularTarjeta = this.pasajeroNombre;
                    this._setDatosIndividualesGuardados(datos);
                    this.yaCompletada = datos.completado === true;
                    this.autorizacionEnviada = this.yaCompletada;
                } else {
                    const cargada = await this._getReservaByHash(this.hash, solicitud);
                    if (solicitud !== this.solicitudCarga) return;
                    if (!cargada) {
                        this.errorCarga = this.copy.errorCarga;
                        return;
                    }
                }
                this.datosCargados = true;
            } catch (error) {
                if (solicitud === this.solicitudCarga) {
                    this.errorCarga = this._mensajeError(error, this.copy.errorCarga);
                }
            } finally {
                if (solicitud === this.solicitudCarga) this.cargando = false;
            }
        },

        async _getReservaByHash(hash, solicitud) {
            const reserva = await this.getReservaByHash([hash]);
            if (!reserva || solicitud !== this.solicitudCarga) return false;
            this.modelReserva.id = reserva.id;
            this.modelReserva.codigo = reserva.codigo;
            this.modelReserva.fecha_inicio = reserva.fecha_inicio;
            this.modelReserva.fecha_llegada = reserva.fecha_llegada;
            this.modelReserva.cant_peregrinos = reserva.cant_peregrinos;
            this.modelReserva.importe_presupuestado = reserva.importe_presupuestado || 0;
            this.modelReserva.camino = reserva.camino;
            this.modelReserva.cliente.nombre = reserva.cliente.nombre;
            this.modelReserva.cliente.apellidos = reserva.cliente.apellidos;
            this.modelReserva.cliente.telefono = reserva.cliente.telefono;
            this.modelReserva.cliente.email = reserva.cliente.email;

            this._setAutorizacionFromReserva(reserva);
            this._setImportesIniciales();
            return true;
        },

        async _enviarAutorizacion() {
            if (!this.puedeEnviarAutorizacion) return;
            if (this.$refs.formAutorizacion && !this.$refs.formAutorizacion.validate()) return;
            this.loadingEnviandoAutorizacion = true;
            this.errorEnvio = '';
            const solicitud = this.solicitudCarga;
            try {
                if (this.esIndividual) {
                    const response = await completarAutorizacionIndividual(this.hash, this.autorizacion);
                    if (!response || !response.data || response.data.completado !== true) {
                        throw new Error('No se ha confirmado el guardado');
                    }
                    if (solicitud !== this.solicitudCarga) return;
                    this.autorizacionEnviada = true;
                    this._setDatosIndividualesGuardados(response.data);
                    return response;
                }
                const payload = {
                    autorizacion_numerotarjeta: this.autorizacion.numeroTarjeta,
                    autorizacion_fechacaducidad: this.autorizacion.fechaCaducidad,
                    autorizacion_titular: this.autorizacion.titularTarjeta,
                    autorizacion_importecarga: this.autorizacion.importeCarga,
                    autorizacion_importedeposito: this.autorizacion.importeDeposito,
                    autorizacion_fechadeposito: this.autorizacion.fechaDeposito,
                    autorizacion_importeresto: this.autorizacion.importeResto,
                };
                const response = await this.guardarAutorizacionTarjeta([this.hash, payload]);
                if (solicitud !== this.solicitudCarga) return;
                if (response) {
                    this.autorizacionEnviada = true;
                } else {
                    this.errorEnvio = this.copy.errorEnvio;
                }
                return response;
            } catch (error) {
                if (solicitud === this.solicitudCarga) {
                    this.errorEnvio = this._mensajeError(error, this.copy.errorEnvio);
                    const status = error && error.response && error.response.status;
                    if (this.esIndividual && (status === 404 || status === 410)) {
                        this.errorCarga = this.errorEnvio;
                        this.errorEnvio = '';
                        this._limpiarTarjeta();
                    }
                }
            } finally {
                this.loadingEnviandoAutorizacion = false;
            }
        },

        _setDatosIndividualesGuardados(datos) {
            if (datos.autorizacion_numerotarjeta != null) this.autorizacion.numeroTarjeta = String(datos.autorizacion_numerotarjeta);
            if (datos.autorizacion_fechacaducidad != null) this.autorizacion.fechaCaducidad = String(datos.autorizacion_fechacaducidad);
            if (datos.autorizacion_titular != null) this.autorizacion.titularTarjeta = String(datos.autorizacion_titular);
            if (datos.autorizacion_fechadeposito) this.autorizacion.fechaDeposito = this._formatFechaDepositoDesdeApi(datos.autorizacion_fechadeposito);
        },

        _limpiarTarjeta() {
            this.autorizacion.numeroTarjeta = '';
            this.autorizacion.fechaCaducidad = '';
            this.autorizacion.titularTarjeta = '';
            this.autorizacion.fechaDeposito = '';
        },

        _mensajeError(error, fallback) {
            const status = error && error.response && error.response.status;
            if (status === 404 || status === 410) return this.copy.enlaceInvalido;
            if (status === 422) return this.copy.errorValidacion;
            return fallback;
        },

        _setImportesIniciales() {
            if (!this.autorizacion.importeCarga) {
                this.autorizacion.importeCarga = this._formatNumero(this.modelReserva.importe_presupuestado);
            }
            if (!this.autorizacion.importeDeposito) {
                this.autorizacion.importeDeposito = '100';
            }
            if (!this.autorizacion.titularTarjeta) {
                const titular = this._getTitularPorDefecto();
                if (titular) {
                    this.autorizacion.titularTarjeta = titular;
                }
            }
            this._actualizarImporteResto();
        },

        _setAutorizacionFromReserva(reserva) {
            if (!reserva) return;
            if (reserva.autorizacion_numerotarjeta) {
                this.autorizacion.numeroTarjeta = String(reserva.autorizacion_numerotarjeta);
            }
            if (reserva.autorizacion_fechacaducidad) {
                this.autorizacion.fechaCaducidad = String(reserva.autorizacion_fechacaducidad);
            }
            if (reserva.autorizacion_titular) {
                this.autorizacion.titularTarjeta = String(reserva.autorizacion_titular);
            }
            if (reserva.autorizacion_importedeposito !== null && reserva.autorizacion_importedeposito !== undefined) {
                this.autorizacion.importeDeposito = this._formatNumero(reserva.autorizacion_importedeposito);
            }
            if (reserva.autorizacion_fechadeposito) {
                this.autorizacion.fechaDeposito = this._formatFechaDepositoDesdeApi(reserva.autorizacion_fechadeposito);
            }
            if (reserva.autorizacion_importeresto !== null && reserva.autorizacion_importeresto !== undefined) {
                this.autorizacion.importeResto = this._formatNumero(reserva.autorizacion_importeresto);
            }
        },

        _actualizarImporteResto() {
            if (this.esIndividual) return;
            const total = this._parseNumero(this.modelReserva.importe_presupuestado);
            const deposito = this._parseNumero(this.autorizacion.importeDeposito);
            const resto = Math.max(0, total - deposito);
            this.autorizacion.importeResto = this._formatNumero(resto);
        },

        _parseNumero(valor) {
            if (valor === null || valor === undefined) return 0;
            const limpio = String(valor).replace(',', '.').replace(/[^\d.]/g, '');
            const num = Number.parseFloat(limpio);
            return Number.isNaN(num) ? 0 : num;
        },

        _formatNumero(valor) {
            const num = this._parseNumero(valor);
            return Number.isInteger(num) ? String(num) : num.toFixed(2);
        },

        _getTitularPorDefecto() {
            const nombre = (this.modelReserva.cliente.nombre || '').trim();
            const apellidos = (this.modelReserva.cliente.apellidos || '').trim();
            const full = `${nombre} ${apellidos}`.trim();
            return full || '';
        },

        _formatFechaDepositoDesdeApi(valor) {
            const texto = String(valor || '').trim();
            const match = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (match) {
                const [, yyyy, mm, dd] = match;
                return `${dd}/${mm}/${yyyy}`;
            }
            return texto;
        },

        onInputNumeroTarjeta(valor) {
            const digits = String(valor || '').replace(/\D/g, '').slice(0, 16);
            this.autorizacion.numeroTarjeta = digits;
        },

        onInputCaducidad(valor) {
            let digits = String(valor || '').replace(/\D/g, '').slice(0, 4);
            if (digits.length >= 3) {
                digits = `${digits.slice(0, 2)}/${digits.slice(2)}`;
            } else if (digits.length >= 2) {
                digits = `${digits.slice(0, 2)}/${digits.slice(2)}`;
            }
            this.autorizacion.fechaCaducidad = digits;
        },

        onInputFechaDeposito(valor) {
            const texto = String(valor || '');
            const input = this._getInputFechaDeposito();
            const cursor = input && typeof input.selectionStart === 'number'
                ? input.selectionStart
                : texto.length;
            const digitosAntesDelCursor = texto.slice(0, cursor).replace(/\D/g, '').length;
            const digitos = texto.replace(/\D/g, '').slice(0, 8);
            const fechaFormateada = this._formatearFechaDeposito(digitos);

            this.autorizacion.fechaDeposito = fechaFormateada;
            this.$nextTick(() => {
                const inputActualizado = this._getInputFechaDeposito();
                if (!inputActualizado) return;
                const nuevaPosicion = this._getPosicionCursorFechaDeposito(
                    fechaFormateada,
                    digitosAntesDelCursor,
                    texto.charAt(cursor) === '/'
                );
                inputActualizado.setSelectionRange(nuevaPosicion, nuevaPosicion);
            });
        },

        _getInputFechaDeposito() {
            const campo = this.$refs.fechaDeposito;
            if (!campo) return null;
            return campo.$refs.input || campo.$el.querySelector('input');
        },

        _formatearFechaDeposito(digitos) {
            if (digitos.length <= 2) return digitos;
            if (digitos.length <= 4) return `${digitos.slice(0, 2)}/${digitos.slice(2)}`;
            return `${digitos.slice(0, 2)}/${digitos.slice(2, 4)}/${digitos.slice(4)}`;
        },

        _getPosicionCursorFechaDeposito(fecha, digitosAntesDelCursor, habiaBarraEnCursor) {
            if (!digitosAntesDelCursor) return 0;

            let digitosRecorridos = 0;
            for (let posicion = 0; posicion < fecha.length; posicion++) {
                if (/\d/.test(fecha.charAt(posicion))) digitosRecorridos++;
                if (digitosRecorridos === digitosAntesDelCursor) {
                    let nuevaPosicion = posicion + 1;
                    if (!habiaBarraEnCursor && fecha.charAt(nuevaPosicion) === '/') {
                        nuevaPosicion++;
                    }
                    return nuevaPosicion;
                }
            }
            return fecha.length;
        },

        validarCamposAutorizacion() {
            const campos = [
                'numeroTarjeta',
                'fechaCaducidad',
                'titularTarjeta',
                'importeCarga',
                'importeDeposito',
                'fechaDeposito',
                'importeResto',
            ];
            const completos = campos.every((campo) => {
                const valor = this.autorizacion[campo];
                return valor !== null && valor !== undefined && String(valor).trim() !== '';
            });
            if (!completos) return false;
            const rulesNumero = this.rulesNumeroTarjeta;
            const rulesCad = this.rulesCaducidad;
            const rulesFecha = this.rulesFechaDeposito;
            const okNumero = rulesNumero.every((r) => r(this.autorizacion.numeroTarjeta) === true);
            const okCad = rulesCad.every((r) => r(this.autorizacion.fechaCaducidad) === true);
            const okFecha = rulesFecha.every((r) => r(this.autorizacion.fechaDeposito) === true);
            return okNumero && okCad && okFecha;
        },

        formatFecha(date) {
            const localeMap = {
                es: 'es-ES',
                en: 'en-US',
                de: 'de-DE',
            };
            const locale = localeMap[this.localeActual] || 'es-ES';
            try {
                return new Intl.DateTimeFormat(locale, {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).format(date);
            } catch (e) {
                return date.toLocaleDateString();
            }
        },
    },
}

</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css';

.card-personalizada {
    border: 4px solid #FF9C00 !important;
    border-radius: 15px !important;
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
